module.exports = __webpack_public_path__ + "static/media/gf.cabf9781.svg";